import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { get } from "lodash";

const FormButtonGroup = ({
  options = [],
  onChange,
  selectedValue,
  style,
  label,
  name,
  disabled,
  disabledValues = [],
}) => {
  const className = disabled ? "disabled" : "";

  return (
    <div
      className={`form-control form-button-group ${className}`}
      style={{ width: "max-content", ...style }}
    >
      <ButtonGroup aria-label={label} name={name}>
        {options.map(({ label, value }, index) => {
          const selectedClass = selectedValue === value ? "selected" : "";
          let buttonProps = {};
          if (!disabled) {
            buttonProps = { onClick: () => onChange(value) };
          }
          if (label === "BASIC") {
            return (
              <Button
                key={index}
                type="button"
                className={selectedClass}
                {...buttonProps}
                disabled={disabled}
                data-attr={value}
                style={{ height: get(style, "height", "") }}
              >
                <div className="display-flex">
                  <div className="marg-right-12">{label}</div>
                  <div className="tooltip-basic">
                    <i
                      class="fal fa-info-circle"
                      style={{
                        marginTop: "4px",
                        fontSize: "12px",
                        lineHeight: "12px",
                        color: "#3A3974",
                      }}
                    />
                    <span className="tooltiptext">
                      Basic (100% on first 3% + 50% on the next 2%)
                    </span>
                  </div>
                </div>
              </Button>
            );
          } else if (label === "QACA" || label === "QACA1") {
            return (
              <Button
                key={index}
                type="button"
                className={selectedClass}
                {...buttonProps}
                disabled={disabled}
                data-attr={value}
                style={{ height: get(style, "height", "") }}
              >
                <div className="display-flex">
                  <div className="marg-right-12">{"QACA"}</div>
                  <div className="tooltip-qaca">
                    <i
                      class="fal fa-info-circle"
                      style={{
                        marginTop: "4px",
                        fontSize: "12px",
                        lineHeight: "12px",
                        color: "#3A3974",
                      }}
                    />
                    <span className={"tooltiptext"}>
                      {(label == "QACA") ? "QACA (100% on first 1% + 50% on the next 5%)" : "QACA (3% of Compensation)"}
                    </span>
                  </div>
                </div>
              </Button>
            );
          } else {
            return (
              <Button
                key={index}
                type="button"
                className={selectedClass}
                {...buttonProps}
                disabled={disabled || disabledValues.some((_) => _ === label)}
                data-attr={value}
                style={{ height: get(style, "height", "") }}
              >
                {label}
              </Button>
            );
          }
        })}
      </ButtonGroup>
    </div>
  );
};

export default FormButtonGroup;
